import * as React from 'react';

import styles from './global-loader.module.styl';

export const GlobalLoader = () => <div className={styles.globalLoading} elref={`globalLoader`} />;
